if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.minNumberInput = this.querySelector('[data-price-range="min-number"]');
      this.maxNumberInput = this.querySelector('[data-price-range="max-number"]');
      this.minSliderInput = this.querySelector('[data-price-range="min-slider"]');
      this.maxSliderInput = this.querySelector('[data-price-range="max-slider"]');
      if (!this.minNumberInput || !this.maxNumberInput || !this.minSliderInput || !this.maxSliderInput) {
        return;
      }

      this.minValue = Number(this.minSliderInput.min);
      this.maxValue = Number(this.maxSliderInput.max);
      this.minGap = 1;
      this.numberDebounce = null;

      this.minSliderInput.addEventListener('input', this.handleSliderInput.bind(this));
      this.maxSliderInput.addEventListener('input', this.handleSliderInput.bind(this));
      this.minNumberInput.addEventListener('input', this.handleNumberInput.bind(this));
      this.maxNumberInput.addEventListener('input', this.handleNumberInput.bind(this));
      this.minNumberInput.addEventListener('change', this.commitNumberInput.bind(this));
      this.maxNumberInput.addEventListener('change', this.commitNumberInput.bind(this));
    }

    handleSliderInput(evt) {
      this.preventHandleCrossing(evt.target);
      this.syncNumberFromSliders();
      this.syncAria();
    }

    handleNumberInput() {
      clearTimeout(this.numberDebounce);
      this.numberDebounce = setTimeout(() => {
        this.commitNumberInput();
      }, 500);
    }

    commitNumberInput() {
      clearTimeout(this.numberDebounce);
      this.clampNumberInputs();
      this.syncSlidersFromNumbers();
      this.syncAria();
      this.dispatchEvent(new CustomEvent('change', { bubbles: true }));
    }

    clampNumberInputs() {
      const min = this.parseInput(this.minNumberInput.value, this.minValue);
      const max = this.parseInput(this.maxNumberInput.value, this.maxValue);
      const safeMin = Math.min(Math.max(min, this.minValue), this.maxValue - this.minGap);
      const safeMax = Math.max(Math.min(max, this.maxValue), this.minValue + this.minGap);

      if (safeMin >= safeMax) {
        if (document.activeElement === this.minNumberInput) {
          this.minNumberInput.value = Math.min(safeMin, safeMax - this.minGap);
          this.maxNumberInput.value = Math.max(safeMax, Number(this.minNumberInput.value) + this.minGap);
        } else {
          this.maxNumberInput.value = Math.max(safeMax, safeMin + this.minGap);
          this.minNumberInput.value = Math.min(safeMin, Number(this.maxNumberInput.value) - this.minGap);
        }
        return;
      }

      this.minNumberInput.value = this.minNumberInput.value === '' ? '' : safeMin;
      this.maxNumberInput.value = this.maxNumberInput.value === '' ? '' : safeMax;
    }

    preventHandleCrossing(target) {
      const min = Number(this.minSliderInput.value);
      const max = Number(this.maxSliderInput.value);

      if (min > max - this.minGap) {
        if (target === this.minSliderInput) {
          this.minSliderInput.value = max - this.minGap;
        } else {
          this.maxSliderInput.value = min + this.minGap;
        }
      }
    }

    syncNumberFromSliders() {
      const min = Number(this.minSliderInput.value);
      const max = Number(this.maxSliderInput.value);
      this.minNumberInput.value = min > this.minValue ? String(min) : '';
      this.maxNumberInput.value = max < this.maxValue ? String(max) : '';
    }

    syncSlidersFromNumbers() {
      const min = this.minNumberInput.value === ''
        ? this.minValue
        : Number(this.minNumberInput.value);
      const max = this.maxNumberInput.value === ''
        ? this.maxValue
        : Number(this.maxNumberInput.value);
      this.minSliderInput.value = String(min);
      this.maxSliderInput.value = String(max);
    }

    syncAria() {
      this.minSliderInput.setAttribute('aria-valuenow', this.minSliderInput.value);
      this.maxSliderInput.setAttribute('aria-valuenow', this.maxSliderInput.value);
    }

    parseInput(value, fallback) {
      if (value === '' || value == null) return fallback;
      const parsed = Number.parseFloat(String(value).replace(',', '.'));
      return Number.isFinite(parsed) ? parsed : fallback;
    }
  }

  customElements.define('price-range', PriceRange);
}
